import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getDefaultLang, LangEnum, LangType } from '../helpers/lang';
import '../i18n/dayjsKz';
import '../i18n/dayjsRu';
import { dayjsLocales, ns } from '../i18n/i18n';

dayjs.extend(isoWeek);

export const useLang = (namespace?: string) => {
  const { t, i18n } = useTranslation(namespace);
  const currentLang = i18n.language as LangEnum;

  const handleChangeLang = async (data: LangEnum) => {
    const importedResources = await import(`../i18n/${data}.json`);
    i18n.addResourceBundle(data, ns, importedResources.default || importedResources);
    await i18n.changeLanguage(data);
  };

  const getLocale = (data?: LangType, forceLang?: LangEnum) => {
    let result;
    if (forceLang) result = data?.[forceLang];
    if (!result) result = data?.[currentLang] || data?.[getDefaultLang()] || '';
    return result;
  };

  useEffect(() => {
    dayjs.locale(dayjsLocales[currentLang]);
  }, [currentLang]);

  return {
    t,
    currentLang,
    handleChangeLang,
    i18n,
    getLocale,
  };
};
